import firebase from './firebase';
import { session } from './session';

export const login = (email, password) => {
  return firebase
    .auth()
    .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    .then(() => {
      return firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(user => session.set('uid', user.uid))
        .catch(error => {
          throw error.message;
        });
    });
};

export const logout = () => {
  return firebase
    .auth()
    .signOut()
    .then(user => session.flush())
    .catch(error => {
      throw error.message;
    });
};

export const sendForgotPasswordEmail = email => {
  return firebase
    .auth()
    .sendPasswordResetEmail(email)
    .catch(error => {
      throw error.message;
    });
};



// WEBPACK FOOTER //
// ./src/services/auth.js